/**
 * SGKC026A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface Sgkc026aReqTankaApprvalauthShutokuinfoDto {

    /**
     * 単価権限区分コード
     */
    tankaauthorityDivcd?: string;
}

